import Vue from "vue";
import App from "./App.vue";
import vuescroll from "vuescroll";
import router from "./router";
import store from "./store";
import axios from "axios";

Vue.config.productionTip = false;

axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL;

// Scroll Config
Vue.use(vuescroll, {
  ops: {
    vuescroll: {
      mode: "native",
      sizeStrategy: "percent",
      detectResize: false,
      locking: true,
      wheelScrollDuration: 0,
      wheelDirectionReverse: true,
      checkShifKey: false,
    },
    scrollPanel: {
      initialScrollY: true,
      initialScrollX: false,
      scrollingX: false,
      scrollingY: true,
      speed: 300,
      easing: undefined,
      verticalNativeBarPos: "right",
    },
    bar: {
      specifyBorderRadius: false,
      size: 14,
      keepShow: true,
    },
  },
  name: "myScroll",
});

//plugins
import "animate.css";

// Set Token Local Storage
if (localStorage.getItem("token")) {
  store.commit("setToken", localStorage.getItem("token"));
}

// Auth Validate
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.state.token) {
      next({
        name: "Login",
      });
    } else {
      next();
    }
  } else {
    if (to.name === "Login" && store.state.token) {
      next({
        path: "/",
      });
    } else {
      next();
    }
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
